<template>
  <div style="height:100vh;overflow:hidden;">
    <!-- <div>认证不通过</div>
    <van-button @click="submit('backAbout')">返回我的</van-button>
    <van-button @click="submit('reauthentication')">重新认证</van-button> -->
    <div class="failed-box">
      <van-image :src="require('/src/assets/image/baiduAI/failed-icon.png')" width="164" height="108px" style="margin-top:60px;margin-bottom:24px;"></van-image>
      <div style="font-size:24px;font-weight:bold;color:#F1BC3F;margin-bottom:24px;">验证不通过</div>
      <div style="font-size:14px;color:#7B7B7B;margin-bottom:40px;">您的身份证识别验证没有通过！</div>
      <div style="width:100%;display:flex;justify-content:space-between;align-items:center;padding:0 23px;box-sizing: border-box;margin-bottom:40px;">
        <van-button class="button" style="border-color:#DDDDDD;color:#7B7B7B;" @click="submit('backAbout')">返回我的</van-button>
        <van-button class="button" type="warning" color="#EC892E" @click="submit('reauthentication')">重新验证</van-button>
      </div>
    </div>
    <div style="display:flex;justify-content:center;align-items:center;">
      <div style="border:1px solid #E94C4E;font-size:14px;padding: 14px;">
        <span style="color:#E94C4E;">注：</span>
        <span style="color:#7B7B7B;">您的人脸识别验证没有通过！</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Button, Image } from 'vant';
export default {
  components: {
    [Button.name]: Button,
    [Image.name]: Image,
  },
  data() {
    return {
      navPagesType: ''
    }
  },
  beforeCreate() {
    // let query = this.$route.query;
    // this.navPagesType = query.type
  },
  created() {
     let query = this.$route.query;
    this.navPagesType = query.type
    if (window.plus) {
      this.handleFindResult();
    }
    else {
      document.addEventListener('plusready', this.handleFindResult, false);
    }
  },
  methods: {
    // async handlePlusReady() {
    //   window.console.log('认证失败页面PlusReady方法====')
    //   await this.createUniWebView();
    //   this.handleFindResult();
    // },
    /* 请求后端查询认证结构 */
    handleFindResult() {
      window.uni.postMessage({
        data: {
          backType: 'findResult'
        }
      });
    },
    submit(backType) {
      window.uni.postMessage({
        data: {
          state: 201,
          msg: '认证失败',
          backType
        }
      });
      if (this.navPagesType == 'auth') {
        window.uni.reLaunch({
          url: '/pages/tabbar/order/index'
        })
      } else if (this.navPagesType == 'driverInfos') {
        window.uni.reLaunch({
          url: '/pages/tabbar/my/index'
        })
      } else if (this.navPagesType == 'noPass') {
        window.uni.reLaunch({
          url: '/pages/tabbar/order/index'
        })
      } else {
        window.uni.reLaunch({
          url: '/pages/tabbar/order/index'
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
body {
  background-color: #f5f5f5;
}
.failed-box {
  box-sizing: content-box;
  margin: 25% 32px 71px 32px;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0px 1px 6px 1px rgba(24, 24, 24, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}
.button {
  width: 114px;
  height: 38px;
  font-size: 16px;
  border-radius: 30px;
  overflow: hidden;
}
</style>